import StatusBadge, { StatusTone } from "@buildpy/ui/status-badge";
import { CONTRACT_STATUS_LABEL, ContractStatus } from "@buildpy/core/modules/contract/types";

// 상태 → 톤. 톤표는 components/status-badge 와 디자인 시스템 StatusBadge 표를 따른다.
export const CONTRACT_STATUS_TONE: Record<ContractStatus, StatusTone> = {
  DRAFT: "hold",
  SENT: "new",
  SIGNED: "progress",
  COMPLETED: "done",
  VOID: "dropped",
  TERMINATED: "dropped",
};

interface Props {
  status: ContractStatus;
  className?: string;
}

const ContractStatusBadge = ({ status, className }: Props) => (
  <StatusBadge className={className} label={CONTRACT_STATUS_LABEL[status]} tone={CONTRACT_STATUS_TONE[status]} />
);

export default ContractStatusBadge;
